import { createContext, useContext, useState } from 'react'

const CurrentUrlContext = createContext()
const CurrentUrlConsumer = CurrentUrlContext.Consumer

const CurrentUrlProvider = ({ children, currentUrl: initialCurrentUrl }) => {
  const [currentUrl] = useState(initialCurrentUrl)

  return <CurrentUrlContext.Provider value={currentUrl}>{children}</CurrentUrlContext.Provider>
}

const useCurrentUrl = () => useContext(CurrentUrlContext)

export default CurrentUrlContext

export { CurrentUrlProvider, CurrentUrlConsumer, useCurrentUrl }
